"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectKansaTgtNendo = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CSelect = _interopRequireDefault(require("01_core/components/materials/CSelect"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styles = require("@mui/material/styles");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const ItemLeft = (0, _styles.styled)(_Grid.default)({
  textAlign: 'left'
});
const ItemRight = (0, _styles.styled)(_Grid.default)({
  textAlign: 'left'
});
const PreparationText = (0, _styles.styled)(_Typography.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    color: 'rgb(49, 71, 218)',
    padding: theme.spacing(1),
    fontSize: theme.typography.body2.fontSize
  };
});

/**
 * @classdesc 監査対象年度と、それに対応する監査テーマを返却する
 * @prop {string} kansaTgtNendo - 選択した年度
 * @prop {function} onChange - 変更時のイベント
 * シグネチャ：(selectNendo:string, selectThemeNm:string, kansaTgtNendoNm:string):void
 * @prop {function} setInitialValue - 初期値
 * シグネチャ：(selectNendo:string, selectThemeNm:string,kansaTgtNendoNm, preparation:bool):void
 * @prop {bool} isSelectable - true: セレクトボックス, false: ラベル
 * @prop {bool} isMsgHidden- true: 非表示, false: 表示
 */
class SelectKansaTgtNendo extends _react.default.Component {
  constructor(props) {
    super(props);
    // 選択した年度が変わった時
    _defineProperty(this, "handleOnChange", kansaTgtNendo => {
      // 選択した年度のレコードを取得（String同士で比較）
      const getSelectedNendo = this.state.nendoInfoList.find(item => String(item.kansaTgtNendo) === String(kansaTgtNendo));
      if (!getSelectedNendo) {
        // 不一致の場合は安全にクリア（異常値を避ける）
        this.setState({
          selectNendo: '',
          selectNendoNm: ''
        });
        return;
      }
      this.setState({
        selectNendo: String(kansaTgtNendo),
        selectNendoNm: getSelectedNendo.kansaTgtNendoNm
      });
      // 呼び出し元に値を返す
      this.props.onChange(String(kansaTgtNendo), getSelectedNendo.kansaThemeNm, getSelectedNendo.kansaTgtNendoNm);
    });
    this.state = {
      // 初期レンダーで out-of-range を避けるため、常に空から開始
      selectNendo: '',
      selectNendoNm: '',
      nendoInfoList: [],
      message: ''
    };
  }
  componentDidMount() {
    const {
      callAPI,
      setInitialValue,
      kansaTgtNendo,
      isMsgHidden
    } = this.props;
    // 監査対象年度取得
    callAPI(_APIs.KANSA_NEND_SEARCH).then(json => {
      if (json.status === _APIs.STATUS.SUCCESS) {
        // 準備中の場合、選択肢から最新年度を取り除く
        const list = Array.isArray(json.data) ? [...json.data] : [];
        if (json.message && !isMsgHidden && list.length > 0) {
          list.shift();
        }
        this.setState({
          nendoInfoList: list,
          message: json.message
        });
        if (!kansaTgtNendo) {
          // 監査対象年度の値を受け取っていない場合、年度の最新をセット
          if (list.length > 0) {
            this.setState({
              selectNendo: String(list[0].kansaTgtNendo),
              selectNendoNm: list[0].kansaTgtNendoNm
            });
            // 呼び出し元に値を返す
            setInitialValue(String(list[0].kansaTgtNendo), list[0].kansaThemeNm, list[0].kansaTgtNendoNm);
          }
        } else {
          // 初期値を呼び出し元へ返す（受け取った監査対象年度）
          // 選択した年度のレコードを取得（String同士で比較）
          const getSelectedNendo = list.find(item => String(item.kansaTgtNendo) === String(kansaTgtNendo));
          if (getSelectedNendo) {
            this.setState({
              selectNendo: String(kansaTgtNendo),
              selectNendoNm: getSelectedNendo.kansaTgtNendoNm
            });
            // 呼び出し元に値を返す
            setInitialValue(String(kansaTgtNendo), getSelectedNendo.kansaThemeNm, getSelectedNendo.kansaTgtNendoNm);
          } else if (list.length > 0) {
            // 受け取った初期値がリストに存在しない場合は最新をセット
            this.setState({
              selectNendo: String(list[0].kansaTgtNendo),
              selectNendoNm: list[0].kansaTgtNendoNm
            });
            setInitialValue(String(list[0].kansaTgtNendo), list[0].kansaThemeNm, list[0].kansaTgtNendoNm);
          }
        }
      }
    }).catch(e => {
      // アンマウントや多重呼び出しの制御用のリジェクトは握りつぶす
      if ((e === null || e === void 0 ? void 0 : e.reason) === 'UNMOUNTED' || (e === null || e === void 0 ? void 0 : e.reason) === 'CALLING') return;
    });
  }
  render() {
    const {
      intl,
      isSelectable,
      isMsgHidden,
      className
    } = this.props;

    // items と safeValue を算出（存在しない value は '' にフォールバック）
    const items = this.state.nendoInfoList.map(data => {
      return {
        displayName: data.kansaTgtNendoNm,
        value: String(data.kansaTgtNendo)
      };
    });
    const values = items.map(i => i.value);
    const safeValue = values.includes(this.state.selectNendo) ? this.state.selectNendo : '';
    return isSelectable ? /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      required: true,
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_TGT_NENDO
      })
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      className: className
    }, /*#__PURE__*/_react.default.createElement(ItemLeft, {
      size: {
        xs: 4
      }
    }, /*#__PURE__*/_react.default.createElement(_CSelect.default, {
      value: safeValue,
      onChange: this.handleOnChange,
      items: items,
      setNone: false,
      disabled: items.length === 0
    })), !isMsgHidden && /*#__PURE__*/_react.default.createElement(ItemRight, {
      size: {
        xs: 8
      }
    }, /*#__PURE__*/_react.default.createElement(PreparationText, null, this.state.message)))) : /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_TGT_NENDO
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      className: className
    }, /*#__PURE__*/_react.default.createElement(ItemLeft, {
      size: {
        xs: 4
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, this.state.selectNendoNm)), !isMsgHidden && /*#__PURE__*/_react.default.createElement(ItemRight, {
      size: {
        xs: 8
      }
    }, /*#__PURE__*/_react.default.createElement(PreparationText, null, this.state.message))));
  }
}
exports.SelectKansaTgtNendo = SelectKansaTgtNendo;
SelectKansaTgtNendo.propTypes = {
  kansaTgtNendo: _propTypes.default.string,
  isSelectable: _propTypes.default.bool.isRequired,
  onChange: _propTypes.default.func.isRequired,
  setInitialValue: _propTypes.default.func,
  isMsgHidden: _propTypes.default.bool
};
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(SelectKansaTgtNendo));